const getSkillIdToTenantUserIds = (tenantUsers) => {
  const ret = {};
  tenantUsers.forEach(tenantUser => {
    tenantUser.skills.forEach(skillId => {
      if (skillId == null) {
        return;
      }

      if (skillId in ret) {
        ret[skillId].push(tenantUser.id);
      } else {
        ret[skillId] = [tenantUser.id];
      }
    });
  });
  return ret;
};

export {
  getSkillIdToTenantUserIds,
};
